import { XIcon } from "@phosphor-icons/react";
import type { ReactNode } from "react";
import { IconButton } from "@/components/ui/icon-button";

export interface WorkflowHeaderProps {
  title: ReactNode;
  center?: ReactNode;
  actions?: ReactNode;
  onClose: () => void;
  isCloseDisabled?: boolean;
}

export const WorkflowHeader = ({
  title,
  center,
  actions,
  onClose,
  isCloseDisabled = false,
}: WorkflowHeaderProps) => (
  <header className="grid h-13.5 w-full shrink-0 grid-cols-[minmax(0,1fr)_auto_minmax(0,1fr)] items-center border-b border-slate-100 bg-white pl-[19px] pr-8">
    <div className="flex min-w-0 items-center gap-4">
      <IconButton
        aria-label="Close and discard"
        variant="icon-only"
        size="sm"
        onPress={onClose}
        isDisabled={isCloseDisabled}
        className="text-gray-900"
        icon={<XIcon aria-hidden className="size-4" />}
      />
      <div aria-hidden className="h-5.5 w-px shrink-0 bg-gray-200" />
      <p className="text-sm font-medium leading-4 text-gray-900">{title}</p>
    </div>

    <div className="justify-self-center">{center}</div>

    <div className="flex min-w-0 items-center justify-end gap-2">{actions}</div>
  </header>
);
